(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-section-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBanners() {
    if (typeof Swiper === 'undefined') {
      // Swiper hasn't finished loading yet; check again shortly
      return setTimeout(initBanners, 50);
    }

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-banner-swiper]').forEach(function (el) {
      if (el.classList.contains('swiper-initialized')) return;

      new Swiper(el, {
        loop: true,
        autoplay: reducedMotion ? false : {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true
        },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev')
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBanners);
  } else {
    initBanners();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
